var _module_exports = "<cdbl-project-scope-doc-activity activity=\"$ctrl.activity\" project=\"$ctrl.task\"></cdbl-project-scope-doc-activity>";;
var path = '/workspace/src/app/components/workroom/activity-stream/activity/templates/project_scope_doc_activity.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;